import { UsersMeResponse } from "@/features/auth/types/api"

/**
 * Check if user is a super admin
 * Super admin is identified by:
 * - Role id === 8, or
 * - Role code starts with "super.admin."
 */
export const isSuperAdmin = (user: UsersMeResponse | null): boolean => {
  if (!user || !user.roles || user.roles.length === 0) {
    return false
  }

  return user.roles.some(
    (role) => role.id === 8 || role.code.startsWith("super.admin.")
  )
}
